import { useEffect } from "react";

export function useScrollRestoration(key) {
  useEffect(() => {
    const savedY = sessionStorage.getItem(`scroll-${key}`);

    if (savedY) {
      window.scrollTo(0, parseInt(savedY, 10));
    }

    const handleScroll = () => {
      sessionStorage.setItem(`scroll-${key}`, window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [key]);
}
